import momentTimezone from 'moment-timezone';
import { Dropdown } from '@morf/ui';
import { FC, memo } from 'react';
import { Option } from '@morf/ui/Dropdown/types';
import { SchedulingTimezonePickerProps } from './types';
import { formatSchedulingTimezone } from './formatSchedulingTimezone';
import { useSchedule } from '../../../components/context/schedule/useSchedule';

const PINNED_TIMEZONE_NAMES = [
  'US/Eastern',
  'US/Central',
  'US/Mountain',
  'US/Pacific',
  'US/Alaska',
  'US/Hawaii',
];

const PINNED_TIMEZONE_VALUES = new Set(PINNED_TIMEZONE_NAMES);

const SchedulingTimezonePicker: FC<SchedulingTimezonePickerProps> = ({}) => {
  const { schedulingTimezone, setSchedulingTimezone } = useSchedule();
  const timezoneNames: string[] = momentTimezone.tz
    .names()
    .filter((tz) => tz.includes('/'));

  const defaultTimezoneOption = {
    label: formatSchedulingTimezone(schedulingTimezone),
    value: schedulingTimezone,
  };

  const timezoneOptions = [
    ...PINNED_TIMEZONE_NAMES.map((timezone) => ({
      label: formatSchedulingTimezone(timezone),
      value: timezone,
    })),
    ...timezoneNames
      .filter((tz) => !PINNED_TIMEZONE_VALUES.has(tz))
      .map((timezone) => ({
        label: formatSchedulingTimezone(timezone),
        value: timezone,
      })),
  ];

  const handleChange = (timezones: Option[]) => {
    const timezone = timezones[0];
    if (timezone) {
      setSchedulingTimezone(timezone.value);
    }
  };

  return (
    <Dropdown
      placeholder='Timezone'
      options={timezoneOptions}
      defaultOptions={[defaultTimezoneOption]}
      onChange={handleChange}
      height='2.25rem'
      searchable
      clearable
      sortOptions={false}
    />
  );
};

export const MemoizedSchedulingTimezonePicker = memo(SchedulingTimezonePicker);
